export const isFieldRequired = required => {
  if (required === true || required === 'required' || required === 'requiredNoAnnotation') {
    return true;
  }
  return false;
};